<template>
  <v-menu
    v-if="switchable"
    :location="location"
    :offset="8"
    content-class="k-glass-3 k-brand__menu"
    :disabled="disabled || switching"
  >
    <template #activator="{ props }">
      <button v-bind="props" type="button" class="k-brand" :class="{ 'k-brand--block': block }">
        <KCompanyLogo :avatar="avatar" :name="name" />
        <span class="k-brand__text">
          <span class="k-brand__app">{{ label }}</span>
          <span class="k-brand__company">{{ name }}</span>
        </span>
        <v-progress-circular v-if="switching" indeterminate size="18" width="2" color="accent" class="ml-auto" />
        <v-icon v-else icon="mdi-unfold-more-horizontal" size="18" class="k-brand__chevron" :class="{ 'ml-auto': block }" />
      </button>
    </template>

    <v-list class="bg-transparent" nav>
      <v-list-subheader>Entreprise active</v-list-subheader>
      <v-list-item
        v-for="item in companies"
        :key="item.id"
        :title="item.name"
        :active="item.id === currentId"
        color="primary"
        rounded="lg"
        @click="$emit('select', item)"
      >
        <template #prepend>
          <KCompanyLogo small :avatar="item.avatar" :name="item.name" />
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
  <div v-else class="k-brand k-brand--static" :class="{ 'k-brand--block': block }">
    <KCompanyLogo :avatar="avatar" :name="name" />
    <span class="k-brand__text">
      <span class="k-brand__app">{{ label }}</span>
      <span class="k-brand__company">{{ name }}</span>
    </span>
  </div>
</template>

<script>
import KCompanyLogo from "@/components/ui/KCompanyLogo";

export default {
  name: "CompanySwitcher",
  components: { KCompanyLogo },
  props: {
    companies: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    avatar: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Katana",
    },
    block: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      default: "bottom start",
    },
    switching: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minCompanies: {
      type: Number,
      default: 0,
    },
  },
  emits: ["select"],
  computed: {
    switchable() {
      return this.companies.length > this.minCompanies;
    },
  },
};
</script>
